import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../config/URL";
import { toast } from "react-toastify";

function PrivacyPolicy() {
  const [content, setContent] = useState("");
  const id = 2;

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const response = await api.get(`/getAllPrivacyPolicySavePublish`);
        if (response.status === 200) {
          setContent(response.data[0]?.privacyPolicyContent || "");
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to fetch privacy policy"
        );
      }
    };

    fetchPrivacyPolicy();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <section style={{ backgroundColor: "#f9fafb" }}>
      <div
        className="container p-5"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
}

export default PrivacyPolicy;
